export enum DisplayOption {
  DataDisplay = 'Data display',
  PercentileHighlights = 'Percentile highlights',
  ASBVtooltip = 'ASBV tooltip'
}
